module.exports = __webpack_public_path__ + "img/2f3497b5-fd1d-4523-8b0b-7b886630c76c.bf3a91d2.jpg";